import React from 'react';
import { StyledPeopleGridWrap } from './StyledPeopleGridWrap';
import PeopleGrid  from '../PeopleGrid';

const PeopleGridWrap = ({ children }) => {
  return (
    <React.Fragment>
      {
        <StyledPeopleGridWrap>
          <h4 className="md--title">People</h4>
          <PeopleGrid />
        </StyledPeopleGridWrap>
          
      }
    </React.Fragment>
  );
};

export default PeopleGridWrap;
